import { DocumentoDTO } from "./documentoDTO";

export class DatiPagamentoDTO {
    dataPagamento: string;
    quietanzaPagamento: DocumentoDTO;
}